import PageHeader from "@/components/PageHeader";
import CTASection from "@/components/CTASection";
import { LANGUAGES } from "@/constants/site";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import SEO, { breadcrumb } from "@/components/SEO";

export default function Languages() {
  return (
    <div>
      <SEO
        title="Foreign & Regional Language Classes — French, German, Japanese, Arabic, Chinese, Russian, Marathi | AM Group of Education"
        description="Learn English, Marathi, French, German, Japanese, Arabic, Chinese and Russian with certified language instructors and live conversation practice."
        path="/languages"
        jsonLd={[
          breadcrumb([
            { name: "Home", path: "/" },
            { name: "Languages", path: "/languages" },
          ]),
        ]}
      />
      <PageHeader
        title="Foreign & Regional Languages"
        subtitle="Open doors across countries — learn from certified language instructors with live conversation practice."
        crumb="Languages"
      />
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
            {LANGUAGES.map((l, i) => (
              <motion.div
                key={l.name}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
                whileHover={{ y: -6 }}
                className="group relative flex flex-col h-full rounded-2xl border border-brand-line bg-brand-cream p-6 sm:p-7 shadow-[0_15px_40px_-25px_rgba(78,52,46,.35)] hover:shadow-[0_30px_70px_-30px_rgba(212,175,55,.45)] overflow-hidden"
                data-testid={`language-card-${l.name.toLowerCase()}`}
              >
                <div className="absolute -top-8 -right-8 text-[7rem] opacity-10 select-none">{l.flag}</div>
                <div className="flex items-center gap-3">
                  <span className="text-3xl" aria-hidden>{l.flag}</span>
                  <h3 className="display-serif text-2xl font-bold text-brand-dark">{l.name}</h3>
                </div>
                <p className="mt-3 text-sm text-brand-mute leading-relaxed flex-1">{l.desc}</p>
                <div className="mt-5 flex items-center justify-between">
                  <div className="text-xs uppercase tracking-widest text-brand-primary font-semibold">
                    <i className="fa-regular fa-clock mr-2" /> {l.duration}
                  </div>
                </div>
                <div className="mt-4 flex flex-wrap gap-2">
                  <Link to="/contact" data-testid={`language-learn-${l.name.toLowerCase()}`} className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-semibold border-2 border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white transition-all">
                    Learn More <i className="fa-solid fa-arrow-right text-[10px]" />
                  </Link>
                  <Link to="/contact" data-testid={`language-enroll-${l.name.toLowerCase()}`} className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-semibold bg-brand-primary text-white hover:bg-brand-gold hover:text-brand-dark transition-all shadow-md">
                    Enquire Now <i className="fa-solid fa-paper-plane text-[10px]" />
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </div>
  );
}
